import { action, observable } from 'mobx';
import { BaseViewStore, } from 'core/stores';
import { ScheduleService } from 'application/schedule/services';

class TaskNotesModalViewStore extends BaseViewStore {
    @observable accessor facilityScheduleDates = null;
    constructor(rootStore, componentProps) {
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'task-notes-modal'
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.scheduleService = scheduleService;
        this.initialize();
    }

    @action.bound
    async initialize() {
        const response = await this.scheduleService.find({facilityOrderId: this.modalParams.data.facilityOrderId, embed: 'Facility,Facility.Corporate_'}); 
        this.facilityScheduleDates = response.data.item;

        const typeResponse = await this.scheduleService.getTypes();
		this.orderingCalendarType = typeResponse.item.find(i => i.abrv === 'ordering');
    }
    
    @action.bound
    async openTask(id) {
        let url = `${this.rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?taskId=${id}&calendarTypeId=${this.orderingCalendarType.id}`;
		window.open(`${url}`);
    }
}

export default TaskNotesModalViewStore;
